import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "./ui/dialog";

/** Owner → gifter thank-you note dialog. */
export default function ThankDialog({ entry, onClose, onSent }) {
  const open = !!entry;
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (entry) {
      setMessage(`Thank you so much for the ${entry.item.product_name} — it means more than you know. 💕`);
    }
  }, [entry]);

  if (!entry) return null;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/thank-yous", { item_id: entry.item.id, message });
      toast.success(`Thank-you sent to ${entry.gifter.display_name}.`);
      onSent?.();
      onClose();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Couldn't send.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="gifters-thank-dialog">
        <DialogHeader>
          <DialogTitle className="font-outfit">Thank {entry.gifter.display_name}</DialogTitle>
          <DialogDescription>For "{entry.item.product_name}".</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={5}
            className="input-soft"
            required
            maxLength={1000}
            data-testid="gifters-thank-message"
          />
          <DialogFooter>
            <button type="button" onClick={onClose} className="btn-ghost">Cancel</button>
            <button type="submit" disabled={submitting} className="btn-primary" data-testid="gifters-thank-submit">
              {submitting ? "Sending…" : "Send thank-you"}
            </button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
